import { __rest } from "tslib";
import * as React from 'react';
import { useConfig } from '../../context';
import { ServiceSummary } from '../../features/service-summary';
const BaggageSummary = (_a) => {
    var { isAnimalBaggage, onServiceDelete } = _a, props = __rest(_a, ["isAnimalBaggage", "onServiceDelete"]);
    const { global: { servicesAvailable: { animal: availableAnimal } } } = useConfig();
    return (React.createElement(ServiceSummary, { serviceType: availableAnimal && isAnimalBaggage ? 'Animal' : 'Baggage', onDelete: onServiceDelete }, content => props.children(content)));
};
export default BaggageSummary;
